import { render, staticRenderFns } from "./Paywall.vue?vue&type=template&id=1be4bd50"
import script from "./Paywall.vue?vue&type=script&lang=js"
export * from "./Paywall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports